<label *ngIf="showLabel">
  {{ label }}<span *ngIf="required" class="required-span">*</span>
  @if(toolTip) {
  <img class="tooptip" src="icons/linear/info.svg" [ngbTooltip]="toolTip" />
  }
</label>
<input
  [tabIndex]="index"
  (input)="inputChanges($event)"
  [id]="id"
  class="indiana-input"
  [ngClass]="className"
  [attr.aria-label]="getLabel()"
  [attr.aria-describedby]="ariaDescribedby || null"
  [attr.aria-invalid]="ariaInvalid ? 'true' : null"
  [type]="type"
  [formControl]="control"
  [placeholder]="placeholder"
  [maxlength]="maxlength"
  [minlength]="minlength"
/>
